import { useSideFilterConfigBuilder } from "./useFilterConfiguration";

export default useSideFilterConfigBuilder;
